import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, ProgressBar } from 'react-bootstrap';
import { FaEdit } from 'react-icons/fa';
import { api } from '../../../components/api/api';
import { Alert, AlertErro } from '../../../util/Alertas';

function ModalEditarStatusPedido({ pedido, statusPedido, onHide, onEdit, onReload, apenasEntregue = false }) {
    const [novoStatus, setNovoStatus] = useState('');
    const [progresso, setProgresso] = useState(0);
    const [motivo, setMotivo] = useState('');
    const [showMotivo, setShowMotivo] = useState(false);

    useEffect(() => {
        setProgresso(0);
        setNovoStatus('');
        setMotivo('')
        setShowMotivo(false);
    }, [pedido]);

    const handleEditarStatus = () => {
        if (novoStatus) {
            const data = new FormData();
            const obj = JSON.stringify({
                PedidoId: pedido.pedido_id,
                StatusPedidoId: novoStatus,
                Motivo: motivo
            });
            data.append("obj", obj);

            try {
                api.post('/api/pedidos/AtualizarStatusPedido', data, res => {
                    Alert('Status do pedido atualizado com sucesso!');
                    if (onReload) {
                        onReload();
                    }
                }, erro => AlertErro(erro, 'Erro ao alterar o status do pedido.'));
            } catch (error) {
                AlertErro(error, 'Erro ao alterar o status do pedido.');
            }

            onEdit(pedido.pedido_id, novoStatus);
            onHide();
        } else {
            Alert('Por favor, selecione um novo status para o pedido.', false, true);
        }
    };

    const handleStatusChange = (e) => {
        setNovoStatus(e.target.value);

        if (e.target.value == 5) {
            setShowMotivo(true)
        }

        setProgresso(0); // Reseta o progresso ao selecionar um novo status
    };

    return (
        <Modal show={true} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title><FaEdit /> Editar Status do Pedido</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {!showMotivo && <Form>
                    <Form.Group controlId="formStatus">
                        <Form.Label>Novo Status do Pedido</Form.Label>
                        <Form.Control as="select" value={novoStatus} onChange={handleStatusChange}>
                            <option value="">Selecione...</option>
                            {!apenasEntregue && statusPedido.map((status) => (
                                <option key={status.status_pedido_id} value={status.status_pedido_id}>{status.nome}</option>
                            ))}
                            {apenasEntregue && <option key={6} value={6}>Entregue</option>}
                        </Form.Control>
                    </Form.Group>
                </Form>}
                {showMotivo && <Form>
                    <Form.Group controlId="formMotivoSelect">
                        <Form.Label>Selecione o motivo</Form.Label>
                        <Form.Control as="select" value={motivo === 'Sem estoque' || motivo === 'Preço' || motivo === 'Prazo' || motivo === 'Desistência' || motivo === 'Erro de digitação' || motivo === 'Cliente não recebeu' || motivo === '' ? motivo : 'Outro'} onChange={e => {
                            if (e.target.value !== 'Outro') {
                                setMotivo(e.target.value);
                            } else {
                                setMotivo('Outro: ');
                            }
                        }}>
                            <option value="">Selecione...</option>
                            <option value="Sem estoque">Sem estoque</option>
                            <option value="Preço">Preço</option>
                            <option value="Prazo">Prazo</option>
                            <option value="Desistência">Desistência</option>
                            <option value="Erro de digitação">Erro de digitação</option>
                            <option value="Cliente não recebeu">Cliente não recebeu</option>
                            <option value="Outro">Outro</option>
                        </Form.Control>
                    </Form.Group>
                    {motivo.startsWith('Outro') && (
                        <Form.Group controlId="formMotivoOutro">
                            <Form.Label>Descreva o motivo (obrigatório)</Form.Label>
                            <Form.Control as="textarea" value={motivo} onChange={e => setMotivo(e.target.value)} />
                            <small>{motivo.length}/150</small>
                        </Form.Group>
                    )}
                </Form>}
                {progresso > 0 && <ProgressBar now={progresso} label={`${progresso}%`} />}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>Cancelar</Button>
                <Button disabled={(novoStatus == '' || novoStatus == 5 && (!motivo || motivo.length < 10 || motivo === 'Outro: '))} variant="primary" onClick={handleEditarStatus}>Salvar</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ModalEditarStatusPedido;
